import React, { useCallback, useState } from 'react'
import { Images } from '@verzekeringapp-mono/shared/src/assets'
import LoginScreenWrapper from '~/components/screen_wrappers/login_screen_wrapper'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Button from '~/components/Button'
import useAuthentication from '@verzekeringapp-mono/shared/src/hooks/use_authentication'
import { getUser } from '@verzekeringapp-mono/shared/src/state/selectors/user'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import Modal from '~/components/Modal'

const VerifyInviteNewUser: React.FC = () => {
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<string>()
  const [message, setMessage] = useState<string>()
  const [isLoading, setIsLoading] = useState(false)

  const token = searchParams.get('token') ?? ''
  const relationNumber = searchParams.get('relation_number') ?? ''
  const email = searchParams.get('email') ?? ''

  const { verifyInviteExisting, refreshSession } = useAuthentication()
  const navigate = useNavigate()

  const user = useAppSelector(getUser)

  const onVerifyInvitePressed = useCallback((async () => {
    try {
      setIsLoading(true)
      const response = await verifyInviteExisting(
        email,
        relationNumber,
        token
      )

      if (user) {
        await refreshSession()

        // Navigating to home.
        // Since we refresh the session there is a high possibility of redirecting to the setup screen.
        navigate('/home')
      } else {
        setMessage(response.message || 'Je uitnodiging is geaccepteerd. Je wordt nu teruggestuurd naar het inlogscherm.')
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      setError(error.message || 'Er is een fout opgetreden bij het aanmaken van je account.')
    } finally {
      setIsLoading(false)
    }
  }
  ), [email, relationNumber, token, user])

  const renderInformationModal = () => (
    <Modal onClose={() => navigate('/auth')}>
      <div className='flex justify-center items-center'>
        <p className='text-center'>{message}</p>
      </div>
    </Modal>
  )

  if (error) {
    return (
      <LoginScreenWrapper>
        <div className='my-4 rounded bg-status-danger-strong p-4 text-text-on-danger'>
          <span className='text-text-on-danger'>{error}</span>
        </div>

        <Button
          className='w-full my-2'
          onClick={() =>{
            setError(undefined)
            setIsLoading(false)
          }}
          type='button'
        >
          Opnieuw proberen
        </Button>
      </LoginScreenWrapper>
    )
  }

  return (
    <LoginScreenWrapper>
      <div>
        <img
          src={Images.Logo}
          width={180}
          height={70}
        />

        <p className='title-medium mt-8'>Uitgenodigd</p>

        <p className='description mt-4 mb-8'>
          Je bent uitgenodigd op adres {email}. Je krijgt toegang met beperkte rechten door op onderstaande knop te klikken.
        </p>

        <Button
          className='w-full my-2'
          isLoading={isLoading}
          onClick={onVerifyInvitePressed}
        >
          Uitnodiging accepteren
        </Button>

        <Button
          className='w-full my-2'
          onClick={() => navigate('/home')}
          variant='outline'
          type='button'
        >
          Terug
        </Button>
      </div>

      {
        message && renderInformationModal()
      }
    </LoginScreenWrapper>
  )
}

export default VerifyInviteNewUser
